<script setup lang="ts">
import { computed } from 'vue';
import InventoryPlaceStock, { type PlaceAction } from './inventory-place-stock.vue';

const props = defineProps<{ patientId: number; archived?: boolean }>();
const place = computed(() => ({ patientId: props.patientId }));

const BALANCE_ACTIONS: PlaceAction[] = [
  { mode: 'use', title: 'Usar', primary: true },
  { mode: 'count', title: 'Ajustar por conteo' },
  { mode: 'transfer', title: 'Trasladar a otro paciente' },
  { mode: 'return', title: 'Devolver a proveedor o bodega' },
  { mode: 'loss', title: 'Pérdida o baja' },
];
const UNIT_ACTIONS: PlaceAction[] = [
  { mode: 'transfer', title: 'Trasladar a otro paciente' },
  { mode: 'return', title: 'Devolver' },
  { mode: 'loss', title: 'Dar de baja' },
];
</script>
<template>
  <div class="d-flex flex-column ga-4">
    <v-alert
      v-if="archived"
      type="info"
      variant="tonal"
      text="Paciente archivado: puedes devolver o trasladar lo que quede en el domicilio, pero no ingresar nada nuevo."
    />
    <inventory-place-stock
      :place="place"
      :balance-actions="BALANCE_ACTIONS"
      :unit-actions="UNIT_ACTIONS"
      :can-enter="!archived"
      empty-text="Sin artículos en el domicilio"
    />
  </div>
</template>
